export default __webpack_public_path__ + "static/media/annualRevenue.0f4e2807.svg";